import axios from '@/assets/utils/https';
import { param } from 'jquery';
import { uploadUrl } from '@/assets/utils/uploadUrl';

export const upload =  params=> axios.post(uploadUrl,params,{ form: "upload" }); // 上传接口


export const getTotalAcc =  params=> axios.post('title/tablelist',params || {}); // 获取总账列表
export const getForeignCurrency =  params=> axios.post('foreignCurrency/findAll',params || {}); // 获取币别
export const getAllSujectByContent =  params=> axios.post('subject/getAllSujectByContent',params || {}); // 获取所有科目
export const changeVoucherSequence =  params=> axios.post('voucherChief/changeVoucherSequence',params || {}); // 插入凭证，调整凭证顺序

/************ 首页接口 ************/

/* 获取首页信息 1,资金类型;2,报表税金;3, 固定资产;4,往来单位;5,经营状况 */
export const findHomePageInfo =  params=> axios.post('financialSetting/findHomePageInfo',params || {});

/* 预估所得税趋势 */
export const findEstimatedIncome =  params=> axios.post('financialSetting/findEstimatedIncome',params || {});

/* 资金总览 */
export const inComeAndOut =  params=> axios.post('financialSetting/inComeAndOut',params || {});


/************* 银行流水 ************/

/** 批量删除银行流水 */
export const deleteBatch = params=>axios.post('/bankStatement/batchDelete',params||{})

/** 凭证预览 */
export const voucherPreview = params=> axios.post('bankStatement/statementVoucherPreview',params||{})

/** 生成凭证 */
export const generateVoucher = params=> axios.post('/bankStatement/generateVoucher',params||{})

/** 更新业务类型 */
export const updateBankBusinessType = params=>axios.post('/bankStatement/updateBankBusinessType',params||{})

/** 获取所有业务类型 */
export const findAllBankBusinessType = params=>axios.post('/bankBusinessType/findAllBankBusinessType',params||{})

/** 删除流水 */
export const deleteBankStatement = params=>axios.post('/bankStatement/delete',params||{})

/** 导入银行流水 */
export const  importBankExcel = params =>axios.post('/bankStatement/importBankStatementByExcel',params||{})

/** 获取所有银行 */
export const findBankName = params =>axios.post('/bankBusinessType/findBankName',params||{})

/** 获取所有银行卡号 */
export const getAllBankNo = params =>axios.post('bankContract/getAllBankNo',params||{})

/** 查询币种 */
export const getForeignBySubjectId = params =>axios.post('/foreignCurrency/getForeignBySubjectId',params||{})

/** 当期导入的统计信息 */
export const getStatisticsInfo = params =>axios.post('/bankStatement/statisticsInfo',params||{})

/** 流水查询 */
export const getStatementList = params =>axios.post('/bankStatement/statementList',params||{})

/** 新增银行 */
export const saveBank = params =>axios.post('/bankContract/save',params||{})

/** 添加银行名称 */
export const saveBankName = params =>axios.post('/bankBusinessType/saveBankName',params||{})

/** 获取业务类型 */
export const findBankBusinessType = params =>axios.post('/bankBusinessType/findBankBusinessType',params||{})

/** 添加/修改 业务类型 */
export const saveBankBusinessType = params =>axios.post('/bankBusinessType/save',params||{})

/** 删除 业务类型 */
export const deleteBankBusinessType = params =>axios.post('/bankBusinessType/delete',params||{})

/** 更新业务类型 可同时设置收入，支出 */
export const  updateTypes = params =>axios.post('/bankStatement/updateBankBusinessTypeV2',params||{})


/************* 审核接口 ************/

// 审核选择列表
export const findExamineList = params =>axios.post('/crm/examine/findExamineList',params||{})
// 审核驳回
export const examineReject = params =>axios.post('/crm/examine/reject',params||{})
// (审核反审核)通过
export const examinePass = params =>axios.post('/crm/examine/pass',params||{})
// 获取历史问题
export const findHistoryProblem = params =>axios.post('/crm/examine/findHistoryProblem',params||{})
// 首页驳回数据
export const findRejects = params =>axios.post('/crm/examine/findRejects',params||{})


/************* 项目上报 ************/

// 查询企业基本情况
export const findRiskReportBasicInformation = params =>axios.post('/crm/risk/findRiskReportBasicInformation',params||{})
// 项目上报-保存项目
export const saveCustomerRiskReport = params =>axios.post('/crm/risk/saveCustomerRiskReport',params||{})
// 查询财务信息--营业收入
export const findRiskReportIncome = params =>axios.post('/crm/risk/findRiskReportIncome',params||{})
// 查询财务信息--税种
export const findRiskReportTax = params =>axios.post('/crm/risk/findRiskReportTax',params||{})


/**五险一金 */

//查询五险一金
export const findInsurance = params =>axios.post('/insurance/findList',params||{})

//新增，编辑 ，五险一金
export const insuranceTask = params =>axios.post('/insurance/save',params||{},{json:true})

//删除五险一金
export const delInsurance = params =>axios.post('insurance/del',params||{})
/**工资表 */


//重置工资表
export const resetSalary = params =>axios.post('salary/saveSalary',params||{})
//导入工资表
export const importSalary = params =>axios.post('/salary/excel/import',params||{},{upload:true})
//导出工资表
export const exportSalary = params =>axios.post('/salary/excel/export',params||{},{json:true})
//查询工资表
export const findSalaryList = params =>axios.post('/salary/findSalaryList',params||{})

//编辑工资表
export const editSalaryList = params =>axios.post('/salary/editSalary',params||{},{json:true})


//查询自定义项目
export const findSetProjectList = params =>axios.post('/salary/findSetProjectList',params||{})

//保存自定义项目
export const saveSetProject = params =>axios.post('/salary/saveSetProject',params||{},{json:true})

//删除自定义项目
export const delSetProject = params =>axios.post('/salary/delSetProject',params||{})


/** 员工 */
export const findEmployeeList = params =>axios.post('/employee/findEmployeeList',params||{})

//导入员工
export const importEmployee = params =>axios.post('/employee/importEmployee',params||{},{upload:true})


//新增员工 保险查询
export const findProjectForEmployee = params =>axios.post('/employee/findProjectForEmployee',params||{})

//新增员工
export const saveEmployee = params =>axios.post('/employee/save',params||{},{json:true})

//删除员工
export const delEmployee = params =>axios.post('employee/del',params||{})
//批量设置部门,科目
export const updateUsersProjectAndDept = params =>axios.post('employee/updateUsersProjectAndDept',params||{})

/** 计提发放 */

//获取计提工资
export const getAccruedSalary = params =>axios.post(`salary/voucher/findAccruedSalary`,params||{} )

//计提发放模板
export const findSalaryVoucherTemplate = params =>axios.post('salary/voucher/findSalaryVoucherTemplate',params||{})

//取值账期
export const findSalaryValueRange = params =>axios.post('salary/voucher/findSalaryValueRange',params||{})

//取值项目
export const findSalaryValueProject = params =>axios.post('salary/voucher/findSalaryValueProject',params||{})

//添加/修改工资模板
export const salaryVoucherTemplateTask = params =>axios.post('salary/voucher/addSalaryVoucherTemplate',params||{})

//删除工资模板
export const deleteTemplate = params =>axios.post('salary/voucher/deleteTemplate',params||{})

/** 审计 */

// 审计年份列表查询
export const findPeriodInfoList = params =>axios.post('audit/findPeriodInfoList',params||{})

// 生成报表
export const genExcels = params =>axios.post('/audit/genExcels',params||{})

// 保存审计设置
export const auditSave = params =>axios.post('/audit/save',params||{})

// 查询审计设置
export const getSettingByCid = params => axios.post('/audit/getSettingByCid',params||{})

// 审计下载
export const auditDownExcels = params =>axios.post('/audit/downExcels',params||{})

// 2023-08-11 协同发票版本接口

export const findVoucherChiefNumber = params =>axios.post('voucherBill/findVoucherChiefNumber',params||{}); // 根据期数获取凭证字
export const relevancyVoucherChief = params =>axios.post('voucherBill/relevancyVoucherChief',params||{}); // 根据关联凭证
export const findBankBusinessRole = params =>axios.post('bankBusinessType/findBankBusinessRole',params||{}); // 获取摘要下拉信息和科目规则
export const getBankBusinessTypeDetail = params =>axios.post('bankBusinessType/getBankBusinessTypeDetail',params||{}); // 获取业务类型详情
export const findVoucherBillInfo = params =>axios.post('voucherBill/findVoucherBillInfo',params||{}); // 获取凭证关联详情
export const updateVoucherBillInfo = params =>axios.post('voucherBill/updateVoucherBillInfo',params||{}); // 保存凭证关联详情


//获取上一次银行流水或发票生成凭证的设置记录
export const findInvoiceStatementHistory = params =>axios.post('bookInfo/findInvoiceStatementHistory',params||{})

//保存上一次银行流水或发票生成凭证的设置记录
export const saveSetting = params =>axios.post('bookInfo/save',params||{})

// 获取上一次凭证打印的打印设置
export const findVoucherChiefPrintTemplate = params =>axios.post('voucherChief/findVoucherChiefPrintTemplate',params || {})

// 获取按钮权限 params：{ permissions: '' }
export const findPermission = params =>axios.post('sys/menu/findPermissionMenu',params||{})
// 获取体检报告 yearPeriods  期间type 1 查询  2 再次查询 cid  token
export const handleRiskCheck = params =>axios.post('self/criticism/riskCheck',params||{})
// 获取会计制度
export const getAccountingList = params =>axios.post('sys/accounting/list',params||{})


//新工资表
export const getPayRollList = params =>axios.post('salary/findSalaryListV2',params||{})

//保存
export const savePayRoll = params =>axios.post('salary/batchSalary',params||{})

//复制上一月
export const copyPrevMonth = params =>axios.post('salary/copyLastMonthSalary',params||{})

//导入工资表
export const importPayExcell = params =>axios.post('salary/excel/importV2',params||{},{upload:true})


//新员工表
export const getStaffList = params =>axios.post('newEmployee/findList',params||{})

//保存员工
export const saveStaff = params =>axios.post('newEmployee/save',params||{})

//导入员工表
export const importStaffExcell = params =>axios.post('newEmployee/importEmployee',params||{},{upload:true})

export const findJsonAreaList = params =>axios.post('newEmployee/findJsonAreaList',params||{})

//新增员工自动填充工号
export const findWorkCode = params =>axios.post('newEmployee/getWorkCode',params||{})

//获取工资表 合计总数
export const findPayRollTotal = params =>axios.post('salary/queryTotal',params||{})


//发票详情 编辑预览凭证查询
export const editInvolvePreview = params =>axios.post('PreVoucherChiefController/editInvolvePreview',params||{})

//查询附件列表
export const getAttachmentList = params =>axios.post('attachment/list',params||{})

//凭证编辑发票
export const editAttachmentInfo = params =>axios.post('attachment/editAttachmentInfo',params||{})

//固定资产修改折旧方式
export const changeDepreciationStatus = params =>axios.post('fixed/changeDepreciationStatus',params||{})

//删除附件列表
export const delAttachment = params =>axios.post('attachment/delete',params||{})


//凭证 查询固定资产
export const findFixedAssets = params =>axios.post('attachment/findFixedAssetsList',params||{})

//凭证 查询工资
export const findPayRoll = params =>axios.post('attachment/findTaxSalaryList',params||{})

//凭证 查询摊销表
export const findAmortization = params =>axios.post('attachment/findAmortizationList',params||{})


//凭证 查询费用报销单
export const findExpenseReimbursementList = params =>axios.post('attachment/findExpenseReimbursementList',params||{})



// WEBPACK FOOTER //
// ./src/api/index.js